export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/licensePermitGroup/state.js